import React from 'react';
import moment from 'moment';
import { Collapse, Gap, Gutter, Icon, Text } from '@common/components';
import { toHumanTimeFormat } from 'works/legacy/lib/date-helper';
import type { ShiftConfigType } from './_use-shift-config-check';

export function ShiftConfigsInfo({
  shiftConfigs,
  boundaryHour,
}: {
  shiftConfigs: ShiftConfigType[];
  boundaryHour: number | null;
}) {
  if (shiftConfigs.length === 0) return null;

  return (
    <Gutter size="lg" direction="top">
      <Collapse className="shift-configs-collapse">
        <Collapse.Panel key="shift-configs" header="View Shift Times">
          {shiftConfigs.map((config) => {
            const isDay = isDayShift(config.startTime, boundaryHour);
            const start = toHumanTimeFormat(moment.parseZone(config.startTime));
            const end = toHumanTimeFormat(moment.parseZone(config.endTime));

            return (
              <Gutter key={config.id} size="sm" direction="bottom">
                <Gap size="xs">
                  <Icon
                    icon={isDay ? 'sun' : 'moon'}
                    color={isDay ? 'harvestGold' : 'skyDarker'}
                  />
                  <Text size="lg">
                    {start} - {end}
                  </Text>
                </Gap>
              </Gutter>
            );
          })}
        </Collapse.Panel>
      </Collapse>
      <style jsx>{`
        :global(
          .shift-configs-collapse.wk-collapse
            > .ant-collapse-item
            > .ant-collapse-header
        ) {
          padding-left: 0;
        }
      `}</style>
    </Gutter>
  );
}

function isDayShift(startTime: string, boundaryHour: number | null): boolean {
  if (boundaryHour === null) return false;

  const hour = moment.parseZone(startTime).hour();
  const nightHour = (boundaryHour + 12) % 24;

  if (boundaryHour <= nightHour) {
    return hour >= boundaryHour && hour < nightHour;
  }
  return hour >= boundaryHour || hour < nightHour;
}
